import "./style.scss";
import { Folder } from "../../../common/interfaces/admin/folder.interface";

const CoursesTree = ({
    list,
    selectedCourse,
    selectCourse
}: {
    list: Folder[];
    selectedCourse?: string;
    selectCourse: (arg1: string) => void;
}) => {
    const handleCourseClick = (courseId: string) => {
        selectCourse(courseId);
    };

    return (
        <div className="course-tree">
            {list.map(course => (
                <div
                    key={course.courseId}
                    className={`course-tree-item${selectedCourse === course.courseId ? " course-tree-item--selected" : ""}`}
                    role="button"
                    tabIndex={0}
                    aria-pressed={selectedCourse === course.courseId}
                    onClick={() => handleCourseClick(course.courseId)}
                    onKeyDown={event => {
                        if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault();
                            handleCourseClick(course.courseId);
                        }
                    }}
                >
                    <span className="course-tree-item__name">
                        {course.slugName === "text-uploader" ? "Uploaded files" : course.name}
                    </span>
                </div>
            ))}
        </div>
    );
};

export default CoursesTree;
